export default __webpack_public_path__ + "static/media/LOCK OUT AND TAG OUT SYSTEM LOTO.999f1d37.JPG";